var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('el-result',{attrs:{"title":"404","subTitle":"糟糕，页面找不到了..."}},[_c('template',{slot:"icon"}),_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }